const tiendas = state => state.tiendas;
const proveedores = state => state.proveedores;
const activos_fijos = state => state.activos_fijos;
const productos = state => state.productos;
const categorias = state => state.categorias;
const subcategorias = state => state.subcategorias;
const unidades_medidas = state => state.unidades_medidas;
const bancos = state => state.bancos;
const cuentas = state => state.cuentas;
const cuentas_bancarias = state => state.cuentas_bancarias;
const posicion = state => state.posicion;
const clientes = state => state.clientes;
const centro_costo = state => state.centro_costo;
const formas_pago = state => state.formas_pago;
const lista_precio = state => state.lista_precio;
const pilotos = state => state.pilotos;

export default {
  tiendas,
  unidades_medidas,
  proveedores,
  activos_fijos,
  productos,
  categorias,
  subcategorias,
  bancos,
  pilotos,
  cuentas,
  cuentas_bancarias,
  posicion,
  clientes,
  centro_costo,
  formas_pago,
  lista_precio,
};